import { forwardRef } from "react";
import { getFormFieldAttrs } from "utils/contentful/helpers";
import { Field, useFormikContext } from "formik";
import TextField from "@/atoms/TextField";

const ContentfulFormikField = forwardRef(
  ({ entry, name, defaults, ...props }, ref) => {
    const { errors, touched } = useFormikContext();
    const cmsAttrs = getFormFieldAttrs(entry, name);
    const { label, placeholder, helpText } = cmsAttrs;
    const error = touched[name] && errors[name];

    const attrs = {
      name,
      label: label || defaults?.label,
      placeholder: placeholder || defaults?.placeholder,
      helpText: helpText || defaults?.helpText,
    };

    return (
      <Field ref={ref} as={TextField} {...props} {...attrs} error={error} />
    );
  }
);

export default ContentfulFormikField;
